import { connectHook } from 'app/common/components/connect-hook';
import { NumberWidget } from './number-widget';
import { useNumberWidget } from './number-widget-hook';

export default connectHook(NumberWidget, useNumberWidget);
